/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faStamp} from '@fortawesome/pro-duotone-svg-icons';

const LicensesIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faStamp} {...props} />
);

export default LicensesIcon;
